import { map } from 'rxjs/operators';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { Component, OnInit, Input, Output } from '@angular/core';
import { Location } from '@angular/common';
import { Transition } from '@uirouter/angular';
import { EventEmitter } from '@angular/core';
import { Training } from '../../../../../_services/training/training.model';

import {
    TrainerService,
    TrainingPlanningAgencyService,
    TrainingPlanningService,
} from '../../../../../_services';

@Component({
    selector: 'planning-detail',
    templateUrl: 'detail.component.html',
    styleUrls: ['detail.component.scss'],
    providers: [TranslatePipe, Location],
})
export class TrainingDetailPlanningDetailComponent implements OnInit {
    @Input() training: Training;
    currentPlannedSession: any = {};
    plannedSession: any = {};

    agencies: any;

    id: any;
    trainingId: string;

    @Output() added: EventEmitter<any> = new EventEmitter();

    constructor(
        private trans: Transition,
        private translateService: TranslateService,
        private trainersService: TrainerService,
        private trainingPlanningService: TrainingPlanningService,
        private trainingPlanningAgencyService: TrainingPlanningAgencyService
    ) {}

    ngOnInit() {
        this.id = this.trans.params()['id'];
        this.trainingId = this.trans.params()['trainingId'];

        if (this.id && this.trainingId) {
            this.load(this.id);
        } else {
            this.currentPlannedSession = {
                trainingTitle: 'Ajouter session',
            };
            this.plannedSession = {
                trainingId: this.trainingId,
            };
        }
        this.trainingPlanningAgencyService
            .findAll()
            .subscribe((agencies) => (this.agencies = agencies));
    }

    searchTrainers(keyword: string) {
        return this.trainersService.search(keyword);
    }

    load(id) {
        this.trainingPlanningService
            .findById(this.trainingId, id)
            .subscribe((plannedSession) => {
                this.plannedSession = Object.assign({}, plannedSession);

                this.plannedSession.trainer = {
                    fullName:
                        plannedSession.trainerFirstName +
                        ' ' +
                        plannedSession.trainerLastName,
                    id: plannedSession.trainerId,
                };

                this.plannedSession.agency = {
                    name: plannedSession.agencyName,
                    id: plannedSession.agencyId,
                };
            });
    }

    save() {
        if (this.plannedSession.trainer) {
            this.plannedSession.trainerId = this.plannedSession.trainer.id;
        }

        if (this.id && this.trainingId) {
            this.plannedSession.trainingId = this.trainingId;
            this.plannedSession.agencyId = this.plannedSession.agency.id;
            this.trainingPlanningService
                .update(this.plannedSession)
                .pipe(
                    map(
                        (_) =>
                            (window.location.href =
                                '#/training/' + this.trainingId)
                    )
                )
                .subscribe();
        } else if (!this.trainingId) {
            this.plannedSession.trainingId = this.id;
            this.plannedSession.agencyId = this.plannedSession.agency.id;
            this.plannedSession.id = null;
            this.trainingPlanningService
                .create(this.plannedSession)
                .pipe(map((_) => this.added.emit()))
                .subscribe();
        }
    }

    formatTrainer(trainer: any): string {
        return trainer.fullName ? trainer.fullName : trainer;
    }

    formatAgency(agency: any): string {
        const agencyName = agency && agency.name ? agency.name : 'unknown';
        const translatedAgencyName = this.translateService.instant(
            `global.agencies.${agencyName}`
        );
        return translatedAgencyName;
    }
}



// WEBPACK FOOTER //
// ./src/app/_screens/training/detail/planning/detail/detail.component.ts